export default "__VITE_ASSET__CfMh0AeQ__"